/*
 * @Author: Huangxianlong
 * @Date: 2023-08-11 16:44:08
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2024-09-27 17:02:37
 * @FilePath: \monitor\src\language\report\query.js
 * @Description: 
 */
const info = {
  CN: {
    queryCriteria: "查询条件",
    queryBtn: "查 询",
    resetBtn: "重 置",
    projectName: "项目名称",
    proNamePla: "请选择项目名称",
    createTime: "创建时间",
    creTimePla: "请选择创建时间",
    open: "开启",
    close: "关闭",
    dataloggerName: "采集器名称",
    dlogrNamePla: "请输入采集器名称",
    dataloggerNamePla: "请选择采集器名称",
    dataloggerStatus: "采集器状态",
    dlogrStatusPla: "请选择采集器状态",
    alarmLevel: "告警级别",
    alarmLevelPla: "请选择告警级别",
    normalStatus: "正常",
    invalidStatus: "无效",
    systemAdmin: "系统管理员",
    projectAdmin: "项目管理员",
    ordinaryUsers: "普通用户",
    loginName: "登录名",
    loginNamePla: "请输入登录名",
    role: "角色",
    rolePla: "请选择角色",
    registerTime: "注册时间",
    registerTimePla: "请选择注册时间",
    alarmTime: "报警时间",
    alarmTimePla: "请选择报警时间",
    status: "状态",
    statusPla: "请选择状态",
    InOperation: "运行中（界面可访问，数据采集）",
    suspend: "暂停（界面不能访问，数据采集）",
    accessible: "可访问（界面可以访问，数据不采集）",
    stop: "停止（界面不能访问，数据不采集）",
    projectStatus: "项目状态",
    projectStatusPla: "请选择项目状态",
    zoneId: "区域编号",
    zoneIdPla: "请输入区域编号",
    zoneName: "区域名称",
    zoneNamePla: "请输入区域名称",
    dataloggerType: "传感器类型",
    dataloggerTypePla: "请选择传感器类型",
    dataloggerTypeRules: "传感器类型不能为空",
    sensorType: "数据类型",
    sensorTypePla: "请选择数据类型",
    sensorTypeRules: "数据类型不能为空",
    outputRawData: "输出初值和原始数据",
    outputRawDataPla: "请选择输出初值和原始数据",
    outputRawDataRules: "输出初值和原始数据不能为空",
    numberOfTimePeriods: "时间段个数",
    numberOfTimePeriodsPla: "请选择时间段个数",
    numberOfTimePeriodsRules: "时间段个数不能为空",
    timePeriod: "时间段-",
    timePeriodPla: "请选择时间段",
    timePeriodRules: "时间段不能为空",
    partition: "分区",
    partitionPla: "请选择分区",
    partitionRules: "分区不能为空",
    section: "断面",
    sectionPla: "请选择断面",
    sectionRules: "断面不能为空",
    referenceTimePeriod: "参照时间段",
    pointName: "测点名称",
    unit: "单位",
    sensorName: "传感器名称",
    referenceTime: "参照时间",
    accumulatedReferenceTime: "参照时间累计",
    time: "时间",
    thisTime: "本次",
    accumulate: "累计",
    initReading:"初值",
    initReadingTime:"初值时间",
    measuredValue:"(测值)",
    change:"(变化)",
  },
  EN: {
    queryCriteria: "Query Criteria",
    queryBtn: "Query",
    resetBtn: "Reset",
    projectName: "Project Name",
    proNamePla: "Please select a project name",
    createTime: "Create Time",
    creTimePla: "Please select the creation time",
    open: "open",
    close: "close",
    dataloggerName: "Datalogger Name",
    dlogrNamePla: "Please enter the datalogger name",
    dataloggerNamePla: "Please select the datalogger name",
    dataloggerStatus: "Datalogger Status",
    dlogrStatusPla: "Please select the datalogger status",
    alarmLevel: "Alarm Level",
    alarmLevelPla: "Please select an alarm level",
    normalStatus: "normal",
    invalidStatus: "invalid",
    systemAdmin: "system administrator",
    projectAdmin: "project administrator",
    ordinaryUsers: "ordinary users",
    loginName: "Login Name",
    loginNamePla: "Please enter your login name",
    role: "Role",
    rolePla: "Please select a role",
    registerTime: "Registration Time",
    registerTimePla: "Please select the registration time",
    alarmTime: "Alarm Time",
    alarmTimePla: "Please select the alarm time",
    status: "Status",
    statusPla: "Please select a status",
    InOperation: "In Operation（Accessible interface, data collection）",
    suspend: "Suspend（Interface not accessible, data collection）",
    accessible: "Accessible（Accessible interface, data not collected）",
    stop: "Stop（Interface not accessible, data not collected）",
    projectStatus: "Project Status",
    projectStatusPla: "Please select project status",
    zoneId: "Zone Id",
    zoneIdPla: "Please enter the zone id",
    zoneName: "Zone Name",
    zoneNamePla: "Please enter the zone name",
    dataloggerType: "Datalogger type",
    dataloggerTypePla: "Please select the type of datalogger type",
    dataloggerTypeRules: "datalogger type cannot be empty",
    sensorType: "Data type",
    sensorTypePla: "Please select the type of data type",
    sensorTypeRules: "Data type cannot be empty",
    outputRawData: "Output initial values and raw data",
    outputRawDataPla: "Please select the output initial value and raw data",
    outputRawDataRules: "Output initial value and original data cannot be empty",
    numberOfTimePeriods: "Number of time periods",
    numberOfTimePeriodsPla: "Please select the number of time periods",
    numberOfTimePeriodsRules: "The number of time periods cannot be empty",
    timePeriod: "Time period - ",
    timePeriodPla: "Please select a time period",
    timePeriodRules: "Time period cannot be empty",
    partition: "Partition",
    partitionPla: "Please select partition",
    partitionRules: "Partition cannot be empty",
    section: "Section",
    sectionPla: "Please select section",
    sectionRules: "Section cannot be empty",
    referenceTimePeriod: "Reference time period",
    pointName: "Point Name",
    unit: "Unit",
    sensorName: "Sensor Name",
    referenceTime: "Reference time",
    accumulatedReferenceTime: "Accumulated reference time",
    time: "Time",
    thisTime: "This time",
    accumulate: "Accumulate",
    initReading:"Initial value",
    initReadingTime:"Initial value time",
    measuredValue:"(Measured value)",
    change:"(change)",
  }
};
export default info; //需要暴露出去



// WEBPACK FOOTER //
// ./src/language/report/query.js